import { gql } from '@/__generated__/gateway';

export const CreateReviewMutation = gql(`
  mutation CreateReviewMutation($input: CreateProductReviewInput!) {
    productReviews {
      createReview(input: $input) {
        id
      }
    }
  }
`);
